import {useState} from 'react'
import exportFromJSON from 'export-from-json'
import {Download} from 'lucide-react'
import {ListFilter} from './ListFilter'
import {LogBox} from '../../core/_models'
import {getAllExportXls} from '../../core/_requests'
import {useAuth} from '../../../../../auth'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddLogBox?: boolean
}

const ListToolbar = (_: PropTypes) => {
  const [isExporting, setIsExporting] = useState(false)
  const auth = useAuth()
  const {state} = useQueryRequest()

  const exportXLS = async () => {
    setIsExporting(true)
    const res = await getAllExportXls(auth.currentUser?.last_company_id, state.filter as Partial<LogBox>)
    const data: LogBox[] = (res) ? res : []
    setIsExporting(false)
    exportFromJSON({ data, fileName: 'cmb-xls-logs', exportType: 'xls' })
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: TOKENS.spacing.sm }}>
      <ListFilter />
      <button
        type='button'
        onClick={exportXLS}
        disabled={isExporting}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          border: `1px solid ${TOKENS.color.border}`,
          background: TOKENS.color.card,
          color: TOKENS.color.text,
          padding: '7px 12px',
          borderRadius: TOKENS.radius.chip,
          fontSize: 12,
          fontWeight: 600,
          cursor: isExporting ? 'wait' : 'pointer',
          boxShadow: TOKENS.shadow.card,
        }}
      >
        {isExporting ? (
          <>Exportando…<span className='spinner-border spinner-border-sm align-middle' style={{ width: 12, height: 12 }} /></>
        ) : (
          <><Download size={14} /> Exportar</>
        )}
      </button>
    </div>
  )
}

export {ListToolbar}
